interface ErrorResponse {
    code: string | number;
    message: string;
    details?: any[];
}

export interface AuthState {
    authData: any | null;
    loading: boolean;
    authDataError: ErrorResponse | null;
}

export enum AuthActionTypes {
    FETCH_AUTH_DATA         = "FETCH_AUTH_DATA",
    FETCH_AUTH_DATA_SUCCESS = "FETCH_AUTH_DATA_SUCCESS",
    FETCH_AUTH_DATA_ERROR   = "FETCH_AUTH_DATA_ERROR",
    CLEAR_AUTH_DATA = "CLEAR_AUTH_DATA",
}

export type AuthCreateAction =
    | { type: AuthActionTypes.FETCH_AUTH_DATA }
    | { type: AuthActionTypes.FETCH_AUTH_DATA_SUCCESS; payload: any }
    | { type: AuthActionTypes.CLEAR_AUTH_DATA; payload: [] }
    | { type: AuthActionTypes.FETCH_AUTH_DATA_ERROR;   payload: ErrorResponse };